import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://supavps2.responda-ai.com'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Função para testar conexão
export async function testConnection() {
  try {
    const { error } = await supabase.from('clientes').select('count').limit(1)
    if (error) {
      console.error('Erro na conexão com Supabase:', error)
      return false
    }
    console.log('Conexão com Supabase estabelecida com sucesso!')
    return true
  } catch (error) {
    console.error('Erro ao conectar com Supabase:', error)
    return false
  }
}